import React, {useState, useMemo, useEffect} from 'react'
import moment from 'moment'
import _ from 'lodash'

import {IconButton, Popover} from '@material-ui/core'
import './Month.scss'
import TimeList from './TimeList'

const PopTimePicker = ({open, anchorEl, disableDatesBefore, date, onClickTime, onClose}) => {
  const handleClose = e => {
    if (onClickTime) {
      onClickTime(e, date)
    }
    if (onClose) {
      onClose(e)
    }
  }

  const handleClickTime = (e, t) => {
    if (onClickTime) {
      onClickTime(e, t)
    }
    if (onClose) {
      onClose(e)
    }
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      classes={{
        paper: 'c-calendar-pop-time',
      }}
    >
      <TimeList date={date} disableDatesBefore={disableDatesBefore} onClickTime={handleClickTime} />
    </Popover>
  )
}

export default PopTimePicker
